var _rect, _rect2, _path, _rect3, _rect4, _path2, _rect5, _rect6, _path3, _rect7, _rect8, _path4, _rect9, _rect0, _path5, _rect1, _rect10, _path6, _rect11, _rect12, _path7, _path8, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _rect13, _path9, _path0, _path1, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCollectiveCalories(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 283,
    height: 149,
    viewBox: "0 0 283 149",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 129.933,
    y: 60.537,
    width: 66,
    height: 66,
    rx: 33,
    transform: "rotate(-4 129.933 60.537)",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 129.933,
    y: 60.537,
    width: 66,
    height: 66,
    rx: 33,
    transform: "rotate(-4 129.933 60.537)",
    stroke: "#FFE1A7",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M157.268 93.0636L158.014 73.5837L173.001 72.5358L169.556 85.7284L178.099 85.131L162.816 112.103L163.563 92.6234L157.268 93.0636Z",
    fill: "#FFB925"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 142,
    y: 1,
    width: 50,
    height: 50,
    rx: 25,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 142,
    y: 1,
    width: 50,
    height: 50,
    rx: 25,
    stroke: "#FFE1A7",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M161 27.0157L162.577 12.4805H173.845L170.577 22.1706H177L164.155 41.5509L165.732 27.0157H161Z",
    fill: "#FFB925"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 94.4208,
    y: 69.9327,
    width: 50,
    height: 50,
    rx: 25,
    transform: "rotate(4 94.4208 69.9327)",
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 94.4208,
    y: 69.9327,
    width: 50,
    height: 50,
    rx: 25,
    transform: "rotate(4 94.4208 69.9327)",
    stroke: "#FFE1A7",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M111.56 97.2108L114.148 82.821L125.388 83.607L121.452 93.0456L127.859 93.4936L113.694 111.931L116.281 97.5409L111.56 97.2108Z",
    fill: "#FFB925"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 95.949,
    y: 19.9853,
    width: 58,
    height: 58,
    rx: 29,
    transform: "rotate(-3 95.949 19.9853)",
    fill: "white"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 95.949,
    y: 19.9853,
    width: 58,
    height: 58,
    rx: 29,
    transform: "rotate(-3 95.949 19.9853)",
    stroke: "#FFE1A7",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M119.499 48.9775L120.449 31.9466L133.577 31.2587L130.361 42.7479L137.844 42.3557L124.062 65.7194L125.012 48.6885L119.499 48.9775Z",
    fill: "#FFB925"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 56.949,
    y: 45.5654,
    width: 50,
    height: 50,
    rx: 25,
    transform: "rotate(-3 56.949 45.5654)",
    fill: "white"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 56.949,
    y: 45.5654,
    width: 50,
    height: 50,
    rx: 25,
    transform: "rotate(-3 56.949 45.5654)",
    stroke: "#FFE1A7",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M77.2842 70.5505L78.0988 55.9526L89.3509 55.3629L86.5949 65.2108L93.0087 64.8746L81.1955 84.9006L82.0101 70.3028L77.2842 70.5505Z",
    fill: "#FFB925"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 67.431,
    y: 4.96571,
    width: 42,
    height: 42,
    rx: 21,
    transform: "rotate(2 67.431 4.96571)",
    fill: "white"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 67.431,
    y: 4.96571,
    width: 42,
    height: 42,
    rx: 21,
    transform: "rotate(2 67.431 4.96571)",
    stroke: "#FFE1A7",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M82.6583 27.3573L84.3948 15.2978L93.7788 15.6255L90.7756 23.6007L96.1245 23.7875L84.8632 39.5543L86.5997 27.4949L82.6583 27.3573Z",
    fill: "#FFB925"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 176.577,
    y: 29.9166,
    width: 42,
    height: 42,
    rx: 21,
    transform: "rotate(5 176.577 29.9166)",
    fill: "white"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 176.577,
    y: 29.9166,
    width: 42,
    height: 42,
    rx: 21,
    transform: "rotate(5 176.577 29.9166)",
    stroke: "#FFE1A7",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M190.612 53.0744L192.978 41.1224L202.331 41.9407L198.915 49.7478L204.247 50.2143L192.176 65.3701L194.541 53.4181L190.612 53.0744Z",
    fill: "#FFB925"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58 91C58 89.8954 58.8954 89 60 89H80.2654C81.2607 89 82.1046 89.7319 82.2453 90.7172L85.7547 115.283C85.8954 116.268 86.7393 117 87.7346 117H188.265C189.261 117 190.105 116.268 190.245 115.283L193.755 90.7172C193.895 89.7319 194.739 89 195.735 89H216C217.105 89 218 89.8954 218 91V117V143C218 144.105 217.105 145 216 145H186H90H60C58.8954 145 58 144.105 58 143V117V91Z",
    fill: "#EEAF37"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 126.5,
    r: 1.5,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 26.5,
    r: 1.5,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 237.5,
    cy: 40.5,
    r: 1.5,
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 281.5,
    cy: 92.5,
    r: 1.5,
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 26.5,
    cy: 90.5,
    r: 1.5,
    fill: "white"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 238.5,
    cy: 108.5,
    r: 1.5,
    fill: "white"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 273.5,
    cy: 9.5,
    r: 1.5,
    fill: "white"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.04,
    width: 216,
    height: 4,
    rx: 2,
    transform: "matrix(1 0 0 -1 30 149)",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 11L42.5 17.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M229.5 9L213.5 15",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M257 67.5L236 64.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M16 70.5L34 69",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollectiveCalories);
export default __webpack_public_path__ + "static/media/collective-calories.7bdda32c237413901a32870760db0ce2.svg";
export { ForwardRef as ReactComponent };